import React, { useRef, useEffect, useState } from 'react';

import { useGameContext } from '../../game/useGameContext';
import { GAME_APPLICATION_TYPE_STATE } from '../../stateManagment';
import { GameApplicationType } from '../../core/enums';
import { controlDrawer } from '../../elementDrawers/control/ControlDrawer';
import classNames from 'classnames';
import { popupService } from '../../services/helperServices/PopupService';

export const Control = ({ children }) => {
  const [popupState, setPopupState] = useState(false);

  const control = useRef(null);
  const { mode } = useGameContext();

  useEffect(() => {
    const subscribers = popupService.subscribe(setPopupState, true);
    return () => {
      subscribers.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (control.current) {
      controlDrawer.execute(control.current, mode);
    }
  }, [control, mode]);

  const controllerClassNames = classNames({
    'game__control': true,
    'game__control-web': GameApplicationType.web === GAME_APPLICATION_TYPE_STATE.getValue(),
    'none': popupState,
    'block': !popupState,
  });

  return (
    <section
      className={controllerClassNames}
      ref={control}
    >
      {children}
    </section>
  );
};
